import { useEffect, useState } from "react";
// import Download from "../index/components/Download";
import Picture from "./components/Picture";
import "./detail.less";
import Video from "./components/Video";
import { getTrendDetail } from "@/api/trend";
import queryString from "query-string";
import { API_RESULT_CODE } from "@/config/types/common";
import { NavBar, Toast } from "antd-mobile";
import { TrendItem, TrendType } from "@/config/types/trend";
// import IconArrow from "@/images/app/arrow.png";
import { isApp, isMiniApp, isSdicHomeApp, openApp } from "@/utils/utils";
import IconError from "@/images/trend/icon-error.png";
import SiteTitle from "@/components/SiteTitle";
import PageLoading from "@/components/Loading";
// import WechatLaunchApp from "@/components/WechatLaunchApp";
import { _route, universalLinkHost } from "@/utils/constant";
import { useNavigate } from "react-router-dom";
import sdicHomeEmit from "@/utils/prototal";
import classNames from "classnames";

export default function TrendDetail() {
  const navigate = useNavigate();
  const parsed = queryString.parse(location.search);
  const [theme, setTheme] = useState("light");
  const [data, setData] = useState<TrendItem>();
  const [loading, setLoading] = useState(true);
  // const [showMask, setShowMask] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>();
  // const [total, setTotal] = useState(0);
  // const [jobList, setJobList] = useState<JobItem[]>([]);
  // const [wechatStatus, setWechatStatus] = useState(true); // 判断微信加载状态
  // const [wechatReady, setWechatReady] = useState(false);
  const [schemaUrl, setSchemaUrl] = useState("");
  const [universalLink, setUniversalLink] = useState("");
  const [statusBarHeight, setStatusBarHeight] = useState(0);

  const getData = async () => {
    setLoading(true);
    try {
      const { code, data, msg } = await getTrendDetail({ trendsId: parsed?.id as string });
      if (code === API_RESULT_CODE.APP_SUCCESS) {
        setData(data as TrendItem);
        const { type } = data || {};
        // const { type, bindingJobsNum = 0 } = data || {};
        // setJobList(data?.jobList || []);
        // setTotal(bindingJobsNum || 0);
        setSchemaUrl(`wealhome://community/detail?trendsId=${parsed?.id}&type=${type}`);
        setUniversalLink(
          `${universalLinkHost}${_route.APP}?action=communityDetail&trendsId=${parsed?.id}&type=${type}`
        );
        if (isApp()) {
          if (history.length === 1) {
            sdicHomeEmit("closeWebview");
          } else {
            navigate(-1);
          }
          sdicHomeEmit("openCommunityDetail", { trendsId: parsed?.id, type });
          return;
        }
        setTheme(type === TrendType.VIDEO ? "dark" : "light");
      } else if (
        [
          API_RESULT_CODE.APP_TREND_AUDIT_FAIL,
          API_RESULT_CODE.APP_TREND_AUDIT_PENDING,
          API_RESULT_CODE.APP_TREND_NOT_EXIST,
          API_RESULT_CODE.APP_TREND_SECRET,
        ].includes(code)
      ) {
        setErrorMsg(msg);
      } else {
        Toast.show(msg || "动态获取失败");
        setErrorMsg("动态获取失败");
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (isSdicHomeApp()) {
      sdicHomeEmit("getStatusBarHeight", {
        onCallback(data: string) {
          if (data) {
            try {
              const { height } = JSON.parse(data);
              if (height > 0) {
                setStatusBarHeight(height);
              }
            } catch (err) {
              console.error(err);
            }
          }
        },
      });
    }
  }, []);

  function openAppTrendDetail() {
    if (!data?.type || !parsed?.id) {
      return;
    }

    // // 安卓微信sdk正常加载时候，提示app操作
    // if (isWechat() && isAndroid() && wechatStatus) {
    //   // 安卓微信走微信sdk
    //   Toast.show("请打开app操作");
    //   return;
    // }

    // if (isQQ() || (isWechat() && isAndroid() && !wechatStatus)) {
    //   setShowMask(true);
    //   return;
    // }
    openApp(schemaUrl, universalLink, true);
  }

  if (loading) {
    return <PageLoading />;
  }

  return (
    <div
      className={classNames("trend-detail", `trend-detail-${theme}`, {
        "app-init-height": isSdicHomeApp() && !statusBarHeight,
      })}
      onClick={openAppTrendDetail}
    >
      <div style={{ height: statusBarHeight }}></div>
      <div className="scroller" style={{ height: `calc(100vh - ${statusBarHeight}px)` }}>
        <SiteTitle title={data?.title ? data?.title : data?.content} />
        {!isMiniApp() && <NavBar onBack={() => navigate(-1)}>动态详情</NavBar>}
        {/* <div onClick={(e: any) => e.stopPropagation()}>
        <Download />
      </div> */}
        {errorMsg && !data ? (
          <div className="error-page">
            <img className="icon-error" src={IconError} alt="" />
            <div className="error-info">{errorMsg}</div>
          </div>
        ) : (
          <>
            {theme === "light" ? (
              <Picture
                data={data as TrendItem}
                // jobList={jobList}
                // total={total}
                // openAppTrendDetail={openAppTrendDetail}
              />
            ) : (
              <Video
                data={data as TrendItem}
                // jobList={jobList}
                // total={total}
                // openAppTrendDetail={openAppTrendDetail}
              />
            )}
            {/* <div
            className="open-app-btn"
            style={{
              display: isWechat() && isAndroid() && wechatStatus && !wechatReady ? "none" : "block",
            }}
          >
            <div className="app-btn">国聘App内打开</div>
            <WechatLaunchApp
              // onError={() => setWechatStatus(false)}
              extinfo={schemaUrl}
              onLaunchError={() => setShowMask(true)}
              onInitReday={() => setWechatReady(true)}
            />
          </div> */}
          </>
        )}

        {/* {showMask ? (
        <div
          className="mask"
          onClick={(e: any) => {
            e.stopPropagation();
            setShowMask(false);
          }}
        >
          <img className="arrow" src={IconArrow} alt="箭头" />
          <div className="tips">
            点击右上角选择
            <br />
            在浏览器打开~
          </div>
        </div>
      ) : null} */}
      </div>
    </div>
  );
}
